// @flow
import React, { memo, type Node } from 'react';
import classNames from '@ta/common.classnames';
import { useFastManipulation } from '@ta/onboarding.common';
import { useLocalize } from '@ta/platform.i18n';
import { type SegmentOption } from './useExplicitPreferencesState';
import styles from './SegmentPicker.css';

type Props = {|
  value: ?SegmentOption,
  onSelect: (?SegmentOption) => mixed,
|};

/**
 * A component that displays a list of possible options, one of which can be chosen
 */
const SegmentPicker = ({ value, onSelect }: Props) => {
  const { localize } = useLocalize();
  const fastManipulationProps = useFastManipulation();

  const renderInput = (optionValue: SegmentOption, label: Node) => (
    <label className={styles.inputContainer} {...fastManipulationProps}>
      <input
        className={styles.input}
        type="checkbox"
        name="cx_explicit_preferences_segment"
        checked={value === optionValue}
        value={optionValue}
        onChange={evt => onSelect(evt.currentTarget.checked ? optionValue : null)}
      />
      <div className={styles.label}>{label}</div>
    </label>
  );

  return (
    <div className={classNames(styles.segmentPicker)}>
      {renderInput('PARTNER', localize('cx_explicit_preferences_segment_partner') /* My partner */)}
      {renderInput('FAMILY', localize('cx_explicit_preferences_segment_family') /* My family */)}
      {renderInput('FRIENDS', localize('cx_explicit_preferences_segment_friends') /* My friends */)}
      {renderInput('SOLO', localize('cx_explicit_preferences_segment_solo') /* Myself */)}
    </div>
  );
};

export default memo<Props>(SegmentPicker);
